<!-- eslint-disable -->
<template lang="pug">
    .telegram-login-widget
        .telegram-login-widget__button(
            v-if="!isLoading && !isVerified"
            ref="telegramButton"
        )
        cs-loader(v-if="isLoading" size="base")
        .telegram-login-widget__verified(v-if="isVerified")
            svg-icon.telegram-login-widget__icon(name="check" size="small")
            span {{ $i18n.t('telegram.telegram_verified') }}
</template>

<script>
/*eslint-disable*/
import TelegramApi from '../api/telegram';

export default {
    name: 'TelegramLoginWidget',
    props: {
        /**
         * Telegram bot username (without @)
         */
        botUsername: {
            type: String,
            required: true
        },
        /**
         * Button size: small, medium, large
         */
        buttonSize: {
            type: String,
            default: 'medium',
            validator: value => ['small', 'medium', 'large'].includes(value)
        },
        /**
         * Whether to show user photo
         */
        showUserPhoto: {
            type: Boolean,
            default: true
        },
        /**
         * Corner radius
         */
        cornerRadius: {
            type: Number,
            default: 20
        },
        /**
         * Initial verified state
         */
        verified: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            isVerified: this.verified
        };
    },
    watch: {
        verified(newVal) {
            this.isVerified = newVal;
        }
    },
    mounted() {
        if (!this.isVerified) {
            this.initTelegramWidget();
        }
    },
    methods: {
        initTelegramWidget() {
            // Create unique callback name
            const callbackName = 'onTelegramAuth_' + this._uid;

            // Register global callback
            window[callbackName] = this.onTelegramAuth;

            // Create and append Telegram script
            const script = document.createElement('script');
            script.src = 'https://telegram.org/js/telegram-widget.js?22';
            script.setAttribute('data-telegram-login', this.botUsername);
            script.setAttribute('data-size', this.buttonSize);
            script.setAttribute('data-radius', this.cornerRadius);
            script.setAttribute('data-request-access', 'write');
            script.setAttribute('data-userpic', this.showUserPhoto.toString());
            script.setAttribute('data-onauth', `${callbackName}(user)`);
            script.async = true;

            this.$refs.telegramButton.appendChild(script);
        },
        async onTelegramAuth(user) {
            this.isLoading = true;

            try {
                const result = await TelegramApi.verify({
                    id: user.id,
                    firstName: user.first_name,
                    lastName: user.last_name || null,
                    username: user.username || null,
                    photoUrl: user.photo_url || null,
                    authDate: user.auth_date,
                    hash: user.hash
                });

                this.isVerified = true;
                this.$emit('verified', result);
                this.$toasted.success(this.$i18n.t('telegram.telegram_linked_success'));

            } catch (error) {
                this.$emit('error', error);
            } finally {
                this.isLoading = false;
            }
        }
    },
    beforeDestroy() {
        // Clean up global callback
        const callbackName = 'onTelegramAuth_' + this._uid;
        delete window[callbackName];
    }
};
</script>

<style lang="scss" scoped>
.telegram-login-widget {
    display: flex;
    align-items: center;
}

.telegram-login-widget__button {
    display: flex;
    justify-content: center;
}

.telegram-login-widget__verified {
    display: flex;
    align-items: center;
    color: $hsl-color-green-58;
    font-size: 16px;
    line-height: 19px;
    justify-content: center;
}

.telegram-login-widget__icon {
    margin-right: 8px;
}
</style>
